import React from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';

export default function CalendarFilter({ value, onChange, entries = [] }) {
  // Cria um Set com as datas que têm anotação no formato YYYY-MM-DD
  const entryDates = new Set(entries.map(e => new Date(e.date).toISOString().slice(0, 10)));

  return (
    <div className="calendar-filter">
      <Calendar
        onChange={onChange}
        value={value}
        locale="en-US"
        tileClassName={({ date, view }) => {
          if (view === 'month') {
            const iso = date.toISOString().slice(0, 10);
            if (entryDates.has(iso)) return 'has-entry';
          }
          return null;
        }}
      />
    </div>
  );
}

